import React, { useState, useEffect } from 'react';
import { Card, CardTitle, ScrollView, CardText, CardActions, Button, Flex, Text } from '@chatui/core';
import HeadeNavbar from '../components/headeNavbar'
import { getTicketList } from '../services/ticket';
import { searchObj } from '../utils/util';

const MyWorkOrder = props => {
  const [ticketList, setTicketList] = useState([]);

  useEffect(() => {
    const search = searchObj(props.location.search);
    if (search && search.account) {
      getTicketList({ account: search.account })
        .then(res => {
          if (res.code === 0 && res.data.code === 0) {
            setTicketList(res.data.data.list)
          }
        })
    } else {
      window.location.replace(`${window.location.origin}/closeWin`)
    }
  }, [props.location, props.history]);

  const tag = (status) => {
    switch (Number(status)) {
      case 0:
        return <Text style={{ fontSize: '18px', color: "var(--yellow)" }}>待处理</Text>
      case 1:
        return <Text style={{ fontSize: '18px', color: "var(--yellow)" }}>处理中</Text>
      case 2:
        return <Text style={{ fontSize: '18px', color: "var(--yellow)" }}>新回复</Text>
      case 3:
        return <Text style={{ fontSize: '18px', color: "#c6d466" }}>待评价</Text>
      case 4:
        return <Text style={{ fontSize: '18px', color: "#c6d466" }}>已处理</Text>
      default:
        return <Text></Text>
    }
  }

  // function checkDirect() {
  //   if (document.documentElement.clientWidth >= document.documentElement.clientHeight) {
  //     return "landscape"; //横屏
  //   } else {
  //     return "portrait"; //竖屏
  //   }
  // }
  if (document.documentElement.clientWidth >= document.documentElement.clientHeight) {
    return (
      <HeadeNavbar title={"我的反馈"} listButton>
        <div style={{ padding: '30px 1em 0 2em' }}>
          <ScrollView
            data={ticketList}
            renderItem={(item, index) => {
              return <Card key={index} fluid style={{ margin: '15px 15px 3px 0px', borderStyle: 'solid none none none', borderColor: "var(--brand-1)", borderWidth: '4px', width: '210px', minWidth: ' 210px', height: document.documentElement.clientHeight - 117, maxHeight: '260px' }}>
                <div style={{ padding: '24px 16px' }}>
                  <Flex justifyContent='space-between' >
                    <Text style={{ fontSize: '18px', fontWeight: 600, color: "var(--brand-1)" }}>单号：{item.id}</Text>{tag(item.fronted_status)}
                  </Flex>
                </div>
                <div style={{ padding: '14px 16px 0px 16px', height: '112px' }}>
                  <Text style={{ fontSize: '15px' }}><span style={{ fontWeight: 600 }}>游戏：</span>{item.gameNickName}</Text><br />
                  <Text style={{ fontSize: '15px' }} truncate={2} breakWord><span style={{ fontWeight: 600 }}>问题类型：</span>{item.classifyName}</Text>
                </div>
                <CardActions style={{position: 'absolute',bottom: '16px',width: '80%',left: '7%',padding: '0 16px'}} >
                  <Button
                    color="primary"
                    onClick={() => { props.history.push({ pathname: '/myWorkOrderInfo', search: props.location.search, query: { ticketId: item.id } }) }}
                  >查询详情</Button>
                </CardActions>
              </Card>
            }}
          />
        </div>
      </HeadeNavbar>
    );
  } else {
    return (
      <HeadeNavbar title={"我的反馈"} listButton>
        <div style={{ padding: '1em 2em' }}>
          {ticketList.map((item, index) => {
            return <Card key={index} fluid style={{ margin: '12px 0px', borderStyle: 'solid none none none', borderColor: "var(--brand-1)", borderWidth: '4px', width: '100%' }}>
              <CardTitle>
                <Flex justifyContent='space-between' >
                  <Text style={{ fontSize: '18px', color: "var(--brand-1)" }}>单号：{item.id}</Text>{tag(item.fronted_status)}
                </Flex>
              </CardTitle>
              <CardText>
                <Text style={{ fontSize: '15px' }}><span style={{ fontWeight: 600 }}>游戏：</span>{item.gameNickName}</Text>
                <Text style={{ fontSize: '15px' }} truncate={2}><span style={{ fontWeight: 600 }}>问题类型：</span>{item.classifyName}</Text>
              </CardText>
              <CardActions>
                <Button
                  color="primary"
                  onClick={() => { props.history.push({ pathname: '/myWorkOrderInfo', search: props.location.search, query: { ticketId: item.id } }) }}
                >查询详情</Button>
              </CardActions>
            </Card>
          })}
        </div>
      </HeadeNavbar>
    );
  }
};

export default MyWorkOrder;
